import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CommonSettings } from 'epay-library';

@Component({
  selector: 'app-ncp-faq',
  templateUrl: './ncp-faq.component.html',
  styleUrls: ['./ncp-faq.component.scss']
})
export class NcpFAQComponent implements OnInit {
  chaturl = '';

  chatLive!: boolean;
  currentTime!: any;

  constructor(private datePipe: DatePipe) {
    this.chaturl = CommonSettings.ChatUrl;
   }

  ngOnInit(): void {
    this.checkBusinessHours();
  }

  openChat() {
    window.open(this.chaturl, '', 'width=510, height=900');
  }

  checkBusinessHours() {
    var businessOpen = new Date();
    businessOpen.setHours(9, 0, 0); //8:00AM CST or 9:00AM EST
    this.datePipe.transform(businessOpen, 'EEEE h:mm:ss a zzzz', "GMT -5"); // Day Time Timezone
    //console.log("BUSINESS OPEN: ", businessOpen)

    var businessClose = new Date();
    businessClose.setHours(17, 30, 0); //4:30PM CST or 5:30PM EST
    this.datePipe.transform(businessClose, 'h:mm:ss a zzzz', "GMT -5"); // Day Time Timezone
    //console.log("BUSINESS CLOSE: ", businessClose)

    var currentTime = new Date();
    this.datePipe.transform(currentTime, 'EEEE h:mm:ss a zzzz', "GMT -5"); // Day Time Timezone
    //console.log("CURRENT TIME: ", currentTime);

    var currentDay = currentTime.toString().split(' ')[0];

    if (currentDay === "Sat" || currentDay === "Sun") {
      this.chatLive = false;
    }
    else {
      if (currentTime >= businessOpen && currentTime <= businessClose) {
        this.chatLive = true;
      }
      else {
        this.chatLive = false;
      }
    }
  }
}
